<template>
  <div class="container">
    <div>
      <!-- {{ props.showPreAssmtStatusMarkDown }} -->

      <b-button v-if="AreIdsShown" pill :style="{ height: '28px' }" class="m-0" variant="outline-primary" size="sm" @click="modalShow = true">
        <font-awesome-icon icon="fa-solid fa-question" size="lg" />
        <!-- <font-awesome-icon v-if="isNewCodeCollapsed" icon="fa-solid fa-angles-up" size="lg" /> -->
        <!-- <font-awesome-icon v-else icon="fa-solid fa-angles-down" size="lg" /> -->
        <!-- <font-awesome-icon icon="fa-regular fa-circle-question" size="lg" /> -->
      </b-button>
      <b-modal
        v-model="modalShow"
        :no-enforce-focus="true"
        scrollable
        size="xl"
        ref="my-modal"
        hide-footer
        title="Pre Assessment Check"
        :content-class="modalTheme"
        :header-class="modalTheme"
        @hide="onMarkdownModalClose"
      >
        <div style="background: transparent; padding: 0px">
          <div style="background: transparent; padding: 0px">
            <!-- <h1>File {{showV38Details.hccDocumentPath28 }}</h1> -->
            <!-- <a class="btn btn-success" :href="'/' + showV38Details.hccDocument28" target="_blank" :download="'/' + showV38Details.hccDocument28"> Download {{ showV38Details.hccDocument28 }}</a> -->
            <!--
            <div style="background: darkblue; padding: 6px">
              <h3 style="color: cyan;">>>Markdown Test  READ from FILE</h3>
              <MarkDownImportFileVITE />
            </div> -->

            <div style="background: transparent; padding: 00px">
              <h3 style="color: cyan">>>Markdown Test vue data markup</h3>
            </div>

            <p v-if="AreIdsShown">
              Did you hear that? They've shut down the main reactor. We'll be destroyed for sure. This is madness! We're doomed! There'll be no escape for the Princess this time. What's that? Artoo!
              Artoo-Detoo, where are you? At last! Where have you been? They're heading in this direction. Send a detachment down to retrieve them. See to it personally, Commander. There'll be no one
              to stop us this time. Yes, sir. Governor Tarkin, we have an emergency alert in detention block A A-twenty-three. The princess! Put all sections on alert! Obi-Wan is here. The Force is
              with him. If you're right, he must not be allowed to escape. Escape is not his plan. I must face him alone. Chewie! Get behind me! Get behind me! Can't get out that way. Nice! Come on!
              It's them! Blast them! Get back to the ship! Where are you going? Come back! He certainly has courage. What good will it do us if he gets himself killed? Come on! I think we took a wrong
              turn. There's no lock! That oughta hold it for a while. Quick, we've got to get across. Close all outboard shields! Close all outboard shields! Yes. We've captured a freighter entering
              the remains of the Alderaan system. It's markings match those of a ship that blasted its way out of Mos Eisley. They must be trying to return the stolen plans to the princess. She may
              yet be of some use to us. Unlock one-five-seven and nine. I suggest we use it! Don't be too proud of this technological terror you've constructed. The ability to destroy a planet is
              insignificant next to the power of the Force. Don't try to frighten us with your sorcerer's ways, Lord Vader. Your sad devotion to that ancient religion has not helped you conjure up the
              stolen data tapes, or given you clairvoyance enough to find the Rebel's hidden fort. It means so much to him. I'll make it up to him next year. I promise. Luke's just not a farmer, Owen.
              Nice! Come on! It's them! Blast them! Get back to the ship! Where are you going? Come back! He certainly has courage. What good will it do us if he gets himself killed? Come on! I think
              we took a wrong turn. There's no lock! That oughta hold it for a while. Quick, we've got to get across. Find the control that extends the bridge. Oh, I think I just blasted it. If it's a
              fast ship. Fast ship? You've never heard of the Millennium Falcon? Should I have? It's the ship that made the Kessel run in less than twelve parsecs! I've outrun Imperial starships, not
              the local bulk-cruisers, mind you. I'm talking about the big Corellian ships now. She's fast enough for you, old man. H'm? Oh, yeah, well, I guess you're too small to run away on me if I
              take this off! Okay. There you go. Well, wait a minute. Where'd she go? Bring her back! Play back the entire message. What message? The one you're carrying inside your rusty innards!
              Luke? Luke! Come to dinner! All right, I'll be right there, Aunt Beru.
            </p>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

const AreIdsShown = ref(true);
const modalShow = ref(false);

const modalTheme = computed(() => userStore.bModalTheme);

onMounted(() => {
  // console.log("onMounted() :      WidgetSummaryListPrimary >>>>");
});
</script>
